export const regexLowerCase = RegExp('(?=.*[a-z])');
export const regexUperCase = RegExp('(?=.*[A-Z])');
export const regexCheckNumeric = RegExp('(?=.*[0-9])');
export const regexSpecialChar = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
export const regexLengthPassword = RegExp('(?=.{6,})');
